import * as React from "react";
const SvgRotationalMechanism = (props) => /* @__PURE__ */ React.createElement("svg", { width: 22.525423, height: 22.213097, viewBox: "0 0 22.525423 22.213097", fill: "none", id: "svg6", xmlSpace: "preserve", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m 17.809799,12.861738 0.910271,-0.508419 1.181521,2.115445 2.115418,-1.181535 0.508414,0.910283 -2.564142,1.432166 c -0.256415,0.143217 -0.566129,0.05548 -0.709345,-0.200932 l -1.432148,-2.564178 z", fill: "currentColor", id: "path5-6-2", style: {
  display: "inline",
  fill: "currentColor",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.999998,
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M 7.8183068,4.7568236 6.9251369,4.218927 8.1751609,2.1432241 6.0994871,0.89318345 6.637375,0 9.153341,1.515201 c 0.2515971,0.1515201 0.3291581,0.46394 0.1776376,0.7155419 L 7.815801,4.746746 Z", fill: "currentColor", id: "path5-6-2-3-35", style: {
  display: "inline",
  fill: "currentColor",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.999998,
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "m 5.8790654,17.460527 0.028359,1.042257 -2.4221143,0.06595 0.065909,2.422148 -1.0422445,0.02838 -0.079893,-2.935937 c -0.00798,-0.293594 0.2133526,-0.52732 0.506943,-0.53531 l 2.9358977,-0.07986 z", fill: "currentColor", id: "path5-6-2-3-3", style: {
  display: "inline",
  fill: "currentColor",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 0.999998,
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M 16.704922,12.701254 V 10.644642 L 15.179069,10.341363 C 15.074819,9.9906974 14.942137,9.6495087 14.762067,9.3367516 L 15.624505,8.0383383 14.174473,6.5882854 12.876075,7.4507351 C 12.563324,7.2801407 12.22214,7.1379786 11.871478,7.0337266 L 11.568203,5.507854 H 9.5116196 L 9.2083442,7.0337266 C 8.8576824,7.1379786 8.5164984,7.2706632 8.2037455,7.4507351 L 6.9053492,6.5882854 5.4553161,8.0383383 6.3177539,9.3367516 C 6.1471623,9.6495087 6.005002,9.9906974 5.9007511,10.341363 l -1.5258519,0.303279 v 2.056612 l 1.5258519,0.303278 c 0.1042504,0.350667 0.2369338,0.691856 0.4170028,1.004613 l -0.8624378,1.298423 1.4500331,1.45005 1.2983963,-0.862447 c 0.3127529,0.170592 0.6539369,0.312756 1.0045987,0.417008 l 0.3032754,1.525871 h 2.0565834 l 0.303275,-1.525872 c 0.350662,-0.104251 0.691846,-0.236937 1.004597,-0.417008 l 1.298398,0.862448 1.450032,-1.45005 -0.862438,-1.298423 c 0.170593,-0.312757 0.312752,-0.653946 0.417002,-1.004613 z m -3.800414,-1.023567 c 0,1.298413 -1.061463,2.35989 -2.359858,2.35989 -1.2983962,0 -2.3598594,-1.061477 -2.3598594,-2.35989 0,-1.298414 1.0614632,-2.3598903 2.3598594,-2.3598903 1.298395,0 2.359858,1.0614763 2.359858,2.3598903 z", fill: "currentColor", id: "path1-0", style: {
  display: "inline",
  strokeWidth: 0.999999
} }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  fillOpacity: 1,
  stroke: "currentColor",
  strokeWidth: 1.50001,
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path9", d: "M 17.868225,18.164567 A 9.7900009,9.7901335 0 0 1 10.686722,21.461985 9.7900009,9.7901335 0 0 1 3.4095647,18.381418" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  fillOpacity: 1,
  stroke: "currentColor",
  strokeWidth: 1.50001,
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "circle18", d: "m 12.51687,2.0845098 a 9.7900009,9.7901335 0 0 1 6.43969,4.5879631 9.7900009,9.7901335 0 0 1 0.949569,7.8497411" }), /* @__PURE__ */ React.createElement("defs", { id: "defs6" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  fillOpacity: 1,
  stroke: "currentColor",
  strokeWidth: 1.50001,
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "circle19", d: "M 1.271254,14.825158 A 9.7900009,9.7901335 0 0 1 1.9739965,6.9327157 9.7900009,9.7901335 0 0 1 8.2878509,2.1453714" }));
export default SvgRotationalMechanism;
